module.exports = __webpack_public_path__ + "static/hahn-icon-8d6d6a8d901680872c27795b66f93342.png";